
import styles from "./guardItem.module.scss"
import * as React from "react";
import { Card, CardContent } from "@material-ui/core";
import { formatDateAndHour } from "helpers/Parsers";
import useWindowSize from "hooks/useWindowSize";
import arrowIconSmall from "assets/images/arrow-icon-small.svg"
import locationIconXs from "assets/images/location-icon-xs.svg"
import Icon from "components/MainApp/atoms/Icon/icon";
import i18n from "i18n";

const renderStatus = status => {
    switch (status) {
      case "ALARM":
        return <span className={` ${styles["new-alert"]} ${styles["span-presis-item"]} `}>{i18n.t("new.alert")}</span>;
      case "FALSE_ALARM":
        return <span className={` ${styles["false-alarm"]} ${styles["span-presis-item"]} `}>{i18n.t("false.alarm")}</span>;
      case "ATTEMPTED_THEFT":
        return <span className={` ${styles["attempted-theft"]}  ${styles["span-presis-item"]} `}>{i18n.t("attempted.theft")}</span>;
      case "THEFT":
        return <span className={` ${styles["theft"]}  ${styles["span-presis-item"]} `}>{i18n.t("theft")}</span>;
      default:
        return <></>;
    }
  };

const GuardItem = ({ 
    alert,
    setAlertSelected
}) => {
    const { date, hour } = formatDateAndHour(alert.created_at);
    const { isMobile } = useWindowSize();

    return isMobile ? (
      <Card mt={0} ml={0} className={styles["card-content-mobile"]}>
        <CardContent onClick={() => setAlertSelected(alert)} className={styles["card-content-presis-item"]}>
          <div className={styles["header-mobile-item-presis"]} >
            <h4>{alert?.device?.name}</h4>
            <p>
              {alert?.tag && <Icon name="tags" fill={"#3C7AF5"} />}
              {renderStatus(alert?.status)}
            </p>
          </div>
          <div className={styles["footer-mobile-item-presis"]}>
            <p>
              <img src={locationIconXs} />
              {alert?.device?.location?.name}
            </p>
            <p>{date} {hour}</p>
          </div>
        </CardContent>
      </Card>
    ) : (
      <Card mt={0} ml={0} className={styles["card-content-desk"]}>
        <CardContent onClick={() => setAlertSelected(alert)} className={styles["card-content-presis-item"]}>
          <p>{date}</p>
          <p>{hour}</p>
          <p>{alert?.device?.name}</p>
          <p>{alert?.device?.location?.name}</p>
          <p>
            {alert?.tag && <Icon name="tags" fill={"#3C7AF5"} />}
            {renderStatus(alert?.status)}
          </p>
          <span>
            <img src={arrowIconSmall} />
          </span>
        </CardContent>
      </Card>
    );
}

export default GuardItem;